import { useTranslation } from 'react-i18next';
import { Separator } from './Separator';
import { ContentWrapperCell } from './ContentWrapperCell';
import { AbsoluteNumberField, MoneyField } from '../../../components';
import { useTagebuchEinstellungen } from '@/domain/controlling/hooks/useTagebuchEinstellungen';
import { Money } from '@/domain/controlling/entities';
import { useStandortContext } from '@/features/standortContext/StandortContext';

export function PrognoseCell({
  absatzPrognose,
  umsatzPrognose,
}: {
  absatzPrognose: number;
  umsatzPrognose: Money;
}) {
  const { t } = useTranslation();
  const {
    currentStandort: { id: standortId },
  } = useStandortContext();
  const { umsatzplanungAnzeige: tagebuchAnzeige } =
    useTagebuchEinstellungen(standortId);

  return (
    <ContentWrapperCell>
      {tagebuchAnzeige !== 'ABSATZ_PRODUKTIVITAET' && (
        <MoneyField value={umsatzPrognose} unit={t(`general.currency.EUR`)} />
      )}
      {tagebuchAnzeige === 'UMSATZ_ABSATZ_PRODUKTIVITAET' && <Separator />}
      {tagebuchAnzeige !== 'UMSATZ_PRODUKTIVITAET' && (
        <AbsoluteNumberField
          value={absatzPrognose}
          unit={t('domain.controlling.umsatzplanung.units.stueck')}
        />
      )}
    </ContentWrapperCell>
  );
}
